/* Итог промокода в серверном режиме теми же словами, что шаблон (pmOkHTML и okLine bot-balance.js), из ответа POST /app/promo/apply
   (kind, amount, expires_at) и подарка другу из me.referral.gift. Даты, числа и экранирование — у движка (kit), слова — словарь профиля (src/i18n). */
import { uiFormat, uiText } from '../../i18n';

export interface PromoGift {
  discount_pct: number;
  discount_state: string;
  discount_ends_at: string | null;
  bonus_expires_at: string;
}
export interface PromoApplied {
  /** partner — промокод партнёра, comm — промокод STEOS */
  kind: 'partner' | 'comm';
  code: string;
  /** Сколько Circle пришло */
  amount: number;
  /** Когда сгорят Circle промокода STEOS (мс) */
  till: number | null;
  /** Подарок другу после промокода партнёра; null — сервер его не вернул */
  gift: PromoGift | null;
  now: number;
}
export interface PromoKit {
  esc(s: string): string;
  date(t: number): string;
  days(n: number): string;
  mono(v: number | string): string;
}

const DAY = 864e5;
/** Скидка на первый пакет: ждёт подписки — «после подписки», идёт — «, ещё N дней» */
function discount(g: PromoGift, now: number, k: PromoKit): string {
  const left = g.discount_state === 'active' && g.discount_ends_at ? Math.max(0, Math.ceil((Date.parse(g.discount_ends_at) - now) / DAY)) : 0;
  const pct = k.mono('−' + g.discount_pct + '%');
  if (g.discount_state === 'waiting') return uiFormat('{0} на первый пакет после подписки', pct);
  return left ? uiFormat('{0} на первый пакет, ещё {1}', pct, k.days(left)) : uiFormat('{0} на первый пакет', pct);
}

/** Итог в листе: заголовок, сколько пришло и пояснение */
export function promoDone(p: PromoApplied, k: PromoKit): { title: string; note: string } {
  if (p.kind === 'comm')
    return { title: uiFormat('Промокод {0} применён', k.esc(p.code)), note: p.till ? uiFormat('Circle сгорят {0}', k.esc(k.date(p.till))) : uiText('Circle начислены') };
  if (!p.gift) return { title: uiText('Промокод применён'), note: uiText('Привязка к партнёру подтверждена') };
  return {
    title: uiText('Промокод применён'),
    note: uiFormat('Скидка {0}. Бонусные Circle сгорят {1}', discount(p.gift, p.now, k), k.esc(k.date(Date.parse(p.gift.bonus_expires_at)))),
  };
}

/** Спокойная строка на странице на месте ссылки «Есть промокод?» */
export function promoLine(p: PromoApplied, k: PromoKit): { title: string; note: string } {
  if (p.kind === 'comm')
    return {
      title: uiFormat('Промокод {0}', k.esc(p.code)),
      note: p.till ? uiFormat('{0} C, сгорят {1}', k.mono('+' + p.amount), k.esc(k.date(p.till))) : `${k.mono('+' + p.amount)} C`,
    };
  if (!p.gift) return { title: uiFormat('Промокод {0} применён', k.esc(p.code)), note: uiText('Привязка к партнёру действует') };
  return { title: uiText('Промокод применён'), note: uiFormat('{0} C и {1}', k.mono('+' + p.amount), discount(p.gift, p.now, k)) };
}

/** Строка «Подарок друга · −20% на первый пакет … после подписки» на странице: скидка ждёт подписки, но промокод партнёра не применён
    здесь же только что — иначе то же говорит строка промокода (как у шаблона: строка над полем не появляется) */
export function giftWaitShown(gift: Pick<PromoGift, 'discount_state'> | null | undefined, promo: { st: string; kind: string }): boolean {
  return gift?.discount_state === 'waiting' && !(promo.st === 'ok' && promo.kind === 'partner');
}
